import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  httpHeaderObject = {};

  constructor(
    private httpClient:HttpClient,
  ) { 
  }

  /**
   * Common htp function to get data with auth token
   * @param url 
   * @param data 
   * @returns 
   */
  public apiAuthPost(url: string, data: any): any {
    let token =  localStorage.getItem('access-token');
    var header = {
      headers:new HttpHeaders()
        .set('Authorization','Bearer '+token)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
    }
    return this.httpClient.post(url, JSON.stringify(data), header).pipe(
      catchError(error=>{
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }

  /**
   * Common htp function to get data with auth token
   * @param url 
   * @param data 
   * @returns 
   */
  public apiAuthGet(url: string): any {
    let token =  localStorage.getItem('access-token');
    var header = {
      headers:new HttpHeaders()
        .set('Authorization','Bearer '+token)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
    }
    return this.httpClient.get(url, header).pipe(
      catchError(error=>{
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }  


  /**
   * Common htp function to get data with auth token
   * @param url 
   * @param data 
   * @returns 
   */
  public apiAuthPostFormData(url: string, data: any): any {
    let token =  localStorage.getItem('access-token');
    var header = {
      headers:new HttpHeaders()
        .set('Authorization','Bearer '+token)
        .set('Accept', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
    }
    return this.httpClient.post(url, data, header).pipe(
      catchError(error=>{
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }

}
